import api from './request'
import {objectToQueryString} from '@/tool/utils'


/*注册*/
export const register = async (request: registerRequest): Promise<registerResponseData> => {
    return await api.post('/user/register', request)
}

/*代理商邀请注册*/
export const agentRegister = async (request: registerRequest): Promise<registerResponseData> => {
    return await api.post('/user/agent/register', request)
}

/*发送验证码*/
export const sendCode = async (request: sendCodeRequest): Promise<sendCodeResponseData> => {
    return await api.post('/common/send/code', request)
}
